import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateEquipmentUse, EquipmentUse, EquipmentUseListResponse, EquipmentUseQueryParams } from '@frontend/equipment/types';

export class EquipmentUseClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchEquipmentUses(queryParams?: ApiQueryParams<EquipmentUseQueryParams>): Promise<EquipmentUseListResponse> {
        return await this.apiPaginated<EquipmentUseListResponse, EquipmentUseQueryParams>(`${this.endpoint}/uses`, queryParams);
    }

    public static async fetchEquipmentCompletedUses(queryParams?: ApiQueryParams<EquipmentUseQueryParams>): Promise<EquipmentUseListResponse> {
        return await this.apiPaginated<EquipmentUseListResponse, EquipmentUseQueryParams>(`${this.endpoint}/completed-uses`, queryParams);
    }

    public static async postEquipmentUse(accountId: string, equipmentId: string, equipmentUse: CreateEquipmentUse): Promise<EquipmentUse> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/uses`, equipmentUse);
        return this.handleResponse<EquipmentUse>(response);
    }

    public static async fetchEquipmentUse(accountId: string, equipmentId: string, equipmentUseId: string): Promise<EquipmentUse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/uses/${equipmentUseId}`);
        return await this.handleResponse<EquipmentUse>(response);
    }

    public static async deleteEquipmentUse(accountId: string, equipmentId: string, equipmentUseId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/uses/${equipmentUseId}`);
        await this.handleVoidResponse(response);
    }
}
